import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ICreateWishCampaignPayload {
    data: any
    fromLocation?: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createWishCampaign = createSlice({
    name: 'campaign/create-wish-campaign',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<ICreateWishCampaignPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createWishCampaignActions = createWishCampaign.actions
export default createWishCampaign.reducer
